// extracted by mini-css-extract-plugin
module.exports = {"modal_GLh2iu":"modal_GLh2iu","header_2q2NtG":"header_2q2NtG","body_1Vs0Wn":"body_1Vs0Wn","footer_1aulnD":"footer_1aulnD","title_hO6HwL":"title_hO6HwL"};